// extracted by mini-css-extract-plugin
export default {"padding":"style_padding__hXaZR","content":"style_content__wzrNg","label":"style_label__9GoRH","buttons":"style_buttons__ZSbMB"};